import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { Container, Tabs, Tab } from 'react-bootstrap';
import PromptsTable from './components/PromptsTable';
import AccountsStatsTable from './components/AccountsStatsTable';

class AiTools extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'prompt-revisions'
    };
  }

  handleTabSelect = (key) => {
    this.setState({ activeTab: key });
  };

  render() {
    return [
      <Helmet key="0" title="AI Tools" />,
      <Container key="1" className='container_tabs'>
        <Tabs
          id="ai-tools-tabs"
          activeKey={this.state.activeTab}
          onSelect={this.handleTabSelect}
          className="mb-3"
        >
          <Tab eventKey="prompt-revisions" title="Prompt Revisions">
            {this.state.activeTab === 'prompt-revisions' && <PromptsTable />}
          </Tab>
          <Tab eventKey="accounts-stats" title="Accounts Stats">
            {this.state.activeTab === 'accounts-stats' && <AccountsStatsTable />}
          </Tab>
        </Tabs>
      </Container>,
    ];
  }
}

export default AiTools;
